/**
 * مقادیر جانشین (fallback) سئو.
 *
 * این پروژه چند-دامنه است: یک استقرار به چندین دامنه سرو می‌شود و هویت هر
 * سایت از API می‌آید. پس این مقادیر فقط دو جا استفاده می‌شوند:
 *   ۱) توسعه‌ی محلی، که در آن origin واقعی وجود ندارد
 *   ۲) وقتی API فیلدی را برنگردانده و باید چیزی نمایش داده شود
 *
 * هیچ‌جای دیگری نباید به `site.url` تکیه کند؛ canonical و sitemap از هدرهای
 * درخواست ساخته می‌شوند.
 */
export const site = {
  /** فقط برای localhost — در پروداکشن origin واقعی درخواست استفاده می‌شود. */
  url: 'http://localhost:3000',
  name: 'Portify',
  title: 'نمونه‌کار و برند شخصی',
  description: 'نمونه‌کار و برند شخصی؛ معرفی خدمات، پروژه‌ها و راه‌های تماس.',
  locale: 'fa_IR'
}
